import { render, staticRenderFns } from "./Stars.vue?vue&type=template&id=d5929bc0&scoped=true&lang=pug"
import script from "./Stars.vue?vue&type=script&lang=js"
export * from "./Stars.vue?vue&type=script&lang=js"
import style0 from "./Stars.vue?vue&type=style&index=0&id=d5929bc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5929bc0",
  null
  
)

export default component.exports